import Vue from "vue";
import App from "./App.vue";
// import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";

Vue.config.productionTip = false;

// Vue.use(require('vue-chartist'))

import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)

// eslint-disable-next-line
Vue.component('apexchart', VueApexCharts)

new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App)
}).$mount("#app");
